import React, { useState } from 'react';
import { FormControl, FormLabel, FormHelperText, Paper, useForkRef, Typography, TextField, Button, CircularProgress, Fade, Backdrop } from '@material-ui/core';
import Signature from './Signature';
import _, { omit, pick, round, slice } from 'lodash';
import PF from "./_Services/publicFunction";
import Qs from "qs";
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "./reducers/app";
import useSound from 'use-sound';
import switchlight from './sounds/switchlight.wav';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker, DatePicker, KeyboardDateTimePicker, KeyboardTimePicker } from "@material-ui/pickers";
import TodayIcon from "@material-ui/icons/UpdateOutlined";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { useSnackbar } from "notistack";
// import Example from "./components/LHTable/Example"
import InteriorTable from "../src/components/LHTable/DataSheet_Virtual"
import Example from '../src/components/LHTable/Example';
import { Dialog, DialogContent, DialogActions, DialogTitle, IconButton, Divider, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ImgList from "../src/components/ImgList/ImgList"
import { indigo, green, red } from '@material-ui/core/colors';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';

const domToImage = require('dom-to-image');

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },

    half_background: {
        background: "linear-gradient(to top, yellow 50%, transparent 50%)"
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    chip: {
        margin: theme.spacing(0.5),
    },
}));

const Match = props => {
    const { enqueueSnackbar } = useSnackbar();
    const [file, setFile] = useState({});
    const [rows, setRows] = useState([]);

    const dispatch = useDispatch();
    const classes = useStyles();
    const initialRender = React.useRef(true);

    const { dark } = useSelector(state => ({
        dark: state.app.dark,
    }));
    const [imageURL, setImage] = React.useState(null);  //提交=>簽名檔img
    const [timestamp, setTime] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [user, setUser] = React.useState({
        email: null,
        personalId: null,
        UserName: null,
    })
    const [settingObj, setObj] = React.useState({
        UserName: { label: "姓名", name: "UserName", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, minLength: 2, maxLength: 30, pattern: "^[^0-9]+$" },
        email: { label: "出生日期", name: "email", type: "email", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12 },
        personalId: { label: "身分證字號", name: "personalId", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, minLength: 10, maxLength: 10 }
    })
    const [playActive] = useSound(
        switchlight,
        { volume: 0.5 }
    );
    //選中的範圍
    const [selected, setSelected] = React.useState({ start: null, end: null })
    //用於表的快速移動至某行
    const listRef = React.createRef();
    //勾選
    const [checkSelections, setCheckSelections] = React.useState(new Map());
    //允許多個勾選
    const [enableCheck, setEnableCheck] = React.useState(true);
    //允許多個勾選
    const [multiChk, setMultiChk] = React.useState(false);
    //總頁數
    const [pageCount, setPageCount] = React.useState(1)
    //第幾頁
    const [pageNo, setPageNo] = React.useState(6)
    const [columns, setColumns] = React.useState({
        qc_id: { label: "ID", name: "qc_id", width: 120, type: "text", required: false, noShowSelect: true, noshowTable: true, noshowTableForever: true, orderSeq: 1 },
        UserName: { label: "姓名", name: "UserName", width: 120, type: "text", required: true, xs: 6, sm: 6, md: 3, orderSeq: 9 },
        barcode: { label: "barcode", width: 120, name: "barcode", type: "text", required: true, xs: 6, sm: 6, md: 3, noShowSelect: true, orderSeq: 3 },
        PersonalId: { label: "PersonalId", name: "PersonalId", width: 120, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, orderSeq: 4 },
        checkdate: { label: "checkdate", name: "checkdate", width: 120, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, orderSeq: 5 },
        UpdateCount: { label: "UpdateCount", name: "UpdateCount", width: 120, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, orderSeq: 6 },
    })
    React.useEffect(() => {
        let noshowTable = [];
        Object.values(columns).map(item => {
            if (item.noshowTable === true) {
                // console.log(item.name)
                noshowTable.push(item.name)
            }
        })
        let showColumns = _.omit(columns, noshowTable)        //轉換
        setOrderRows(prev => PF.dataSheetGridFormat(rows, Object.keys(showColumns)))
    }, [columns])
    //轉換
    let noshowTable = [];
    Object.values(columns).map(item => {
        if (item.noshowTable === true) {
            // console.log(item.name)
            noshowTable.push(item.name)
        }
    })
    let showColumns = _.omit(columns, noshowTable)
    // const [showColumns, setShowColumn] = React.useState(_.omit(columns, noshowTable))
    //let z22 = _.orderBy(z2, ['orderSeq']);  //排序
    //let z3 = z2.map(item=>(item.name));//只取標頭
    // console.log(z22);     //依照column順序排序
    const [orderRows, setOrderRows] = React.useState(PF.dataSheetGridFormat(rows, Object.keys(showColumns)))
    //雙擊
    const handleDoubleClick = (i, j, e) => {
        // console.log(rows[i]);
        // setDialogObj(rows[i])
        getBarcode(rows[i]["qc_id"]);
        getBarcodeGaugeItem(rows[i]["barcode"])
    }
    const handleSubmit = e => {
        e.preventDefault();
    }
    const [DialogObj, setDialogObj] = React.useState({});
    React.useEffect(() => {
        GetItem();
    }, [])


    const getBarcode = (qc_id) => {
        PF.instance({
            method: "post",
            url: PF.url + "/Match/QueryBarcode",
            data: Qs.stringify({ parameter: { qc_id } })
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                // alert("完成")
                const { TotalRecord, rows } = response.data;
                if (TotalRecord > 0) {
                    // console.log(rows);
                    //解析圖片為JSON物件
                    let PicJson = JSON.parse(rows[0]["pic"]);
                    // console.log(PicJson);

                    Object.keys(PicJson || {}).map(pic => {
                        // console.log(pic)
                        setPicObj(prev => ({
                            ...prev,
                            [pic]: PicJson[pic]?.split(',') || []
                        }))
                    });

                    setDialogObj(prev => rows[0]);
                    // setDialogObj(rows[i]["qc_id"]);
                    setOpenDialog(true);

                }
                else {
                }
            })
    }
    const PicCategoryArray = ["超音波檢查", "數位斷層合成掃描",
        , "一般X光"
        , "三連片"
        , "內視鏡"
        , "身體組成分析"
        , "心電圖"
        , "自律神經檢查"
        , "眼底攝影"]
    const [GaugeItem, setGaugeItem] = React.useState({

    })
    const getBarcodeGaugeItem = (BarCodeStr) => {
        PF.instance({
            method: "post",
            url: PF.url + "/Match/GetGaugeData",
            data: Qs.stringify({ parameter: { BarCodeStr } })
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                // alert("完成")
                const { TotalRecord, rows } = response.data;
                if (TotalRecord > 0) {
                    // console.log(rows);
                    let ContentJson = JSON.parse(rows[0]["content"]);
                    // console.log(ContentJson);

                    let ItemArray = PF.multiFilter(ContentJson, { CheckCategory: PicCategoryArray });
                    // console.log(ItemArray);
                    let object = _.keyBy(ItemArray, 'CheckCategory');
                    // console.log(object);
                    let y = {}
                    Object.keys(object).map(CheckCategory => {
                        y[CheckCategory] = PF.multiFilter(ContentJson, { CheckCategory: CheckCategory })
                    })
                    console.log(y);
                    setGaugeItem(y)
                }
                else {
                }
            })
    }





    // const handleTxtChange = e => {
    //     const { name, value } = e.target;
    //     setUser(prevstate => ({
    //         ...prevstate,
    //         [name]: value.trim()
    //     }));

    // }
    const formRef = React.createRef();
    const specialFormat = string => {
        return encodeURI(string.replaceAll("\\", "/").replace("//192.168.25.20", "/Content/Upload"))
    }
    // let user_id = "F127150943";
    // React.useEffect(() => {
    //     if (initialRender.current) {
    //         initialRender.current = false;
    //     } else {
    //         const map1 = new Map(
    //             [...checkSelections]
    //                 .filter(([k, v]) => v === true)
    //         );
    //         setUser(prev => ({
    //             ...prev,
    //             personalId: rows[[...map1.keys()][0]]["personalId"]
    //         }))

    //     }


    // }, [checkSelections])

    const handleTest = e => {
        e.preventDefault();
        let one;
        const map1 = new Map(
            [...checkSelections]
                .filter(([k, v]) => v === true)
        );
        // let index = [...checkSelections][0][0];
        if (!_.isEmpty(rows[[...map1.keys()][0]])) {
            one = rows[[...map1.keys()][0]]
        } else {
            alert("請選擇一筆")
        }
        // console.log(personalId)
        // console.log(one)
        const personalId = one?.PersonalId;

        if (!_.isEmpty(MornJoy.CheckDate.value) && !_.isEmpty(personalId)) {

            let person = file[personalId];
            let one = rows.find(item => item.PersonalId === personalId)


            let bigperson = {}
            let bigpersonCount = {}

            if (!_.isEmpty(person)) {

                let pic_7010 = person.filter(function (person) { return person.FullPath.includes("\\腹部超音波Abdominal echo\\"); });
                if (!_.isEmpty(pic_7010)) {
                    console.log(pic_7010)
                    bigperson.pic_7010 = pic_7010;
                    bigpersonCount.pic_7010_alt = "§".repeat(pic_7010.length - 1);
                }

                let pic_7011 = person.filter(function (person) { return person.FullPath.includes("\\攝護腺超音波Prostate echo\\"); });
                if (!_.isEmpty(pic_7011)) {
                    bigperson.pic_7011 = pic_7011;
                    bigpersonCount.pic_7011_alt = "§".repeat(pic_7011.length - 1);
                }

                let pic_7012 = person.filter(function (person) { return person.FullPath.includes("\\乳房超音波Breast Ultrasound\\"); });
                if (!_.isEmpty(pic_7012)) {
                    bigperson.pic_7012 = pic_7012;
                    bigpersonCount.pic_7012_alt = "§".repeat(pic_7012.length - 1);
                }

                let pic_7013 = person.filter(function (person) { return person.FullPath.includes("\\骨盆腔婦科超音波Gynecology Ultrasound\\"); });
                if (!_.isEmpty(pic_7013)) {
                    bigperson.pic_7013 = pic_7013;
                    bigpersonCount.pic_7013_alt = "§".repeat(pic_7013.length - 1);
                }



                let pic_7015 = person.filter(function (person) { return person.FullPath.includes("\\頸動脈超音波Carotid Duplex Ultrasound\\"); });
                if (!_.isEmpty(pic_7015)) {
                    bigperson.pic_7015 = pic_7015;
                    bigpersonCount.pic_7015_alt = "§".repeat(pic_7015.length - 1);
                }

                let pic_7014 = person.filter(function (person) { return person.FullPath.includes("\\甲狀腺超音波Thyroid echo\\"); });
                if (!_.isEmpty(pic_7014)) {
                    bigperson.pic_7014 = pic_7014;
                    bigpersonCount.pic_7014_alt = "§".repeat(pic_7014.length - 1);
                }

                let pic_7016 = person.filter(function (person) { return person.FullPath.includes("\\心臟超音波Cardiac echo\\"); });
                if (!_.isEmpty(pic_7016)) {
                    bigperson.pic_7016 = pic_7016;
                    bigpersonCount.pic_7016_alt = "§".repeat(pic_7016.length - 1);
                }

                let pic_7049 = person.filter(function (person) { return person.FullPath.includes("\\胸部數位雙能量減影\\"); });
                if (!_.isEmpty(pic_7049)) {
                    bigperson.pic_7049 = pic_7049;
                    bigpersonCount.pic_7049_alt = "§".repeat(pic_7049.length - 1);
                }

                let pic_7033 = person.filter(function (person) { return person.FullPath.includes("\\胸部CXR\\"); });
                if (!_.isEmpty(pic_7033)) {
                    bigperson.pic_7033 = pic_7033;
                    bigpersonCount.pic_7033_alt = "§".repeat(pic_7033.length - 1);
                }
                let pic_7093 = person.filter(function (person) { return person.FullPath.includes("\\胸部CXR-側面\\"); });
                if (!_.isEmpty(pic_7093)) {
                    bigperson.pic_7093 = pic_7093;
                    bigpersonCount.pic_7093_alt = "§".repeat(pic_7093.length - 1);
                }

                let pic_7034 = person.filter(function (person) { return person.FullPath.includes("\\腹部KUB\\"); });
                if (!_.isEmpty(pic_7034)) {
                    bigperson.pic_7034 = pic_7034;
                    bigpersonCount.pic_7034_alt = "§".repeat(pic_7034.length - 1);
                }

                let pic_7035 = person.filter(function (person) { return person.FullPath.includes("\\頸椎X光-正面\\"); });
                if (!_.isEmpty(pic_7035)) {
                    bigperson.pic_7035 = pic_7035;
                    bigpersonCount.pic_7035_alt = "§".repeat(pic_7035.length - 1);
                }

                let pic_7036 = person.filter(function (person) { return person.FullPath.includes("\\頸椎X光-側面\\"); });
                if (!_.isEmpty(pic_7036)) {
                    bigperson.pic_7036 = pic_7036;
                    bigpersonCount.pic_7036_alt = "§".repeat(pic_7036.length - 1);
                }

                let pic_7037 = person.filter(function (person) { return person.FullPath.includes("\\胸椎X光-側面\\"); });
                if (!_.isEmpty(pic_7037)) {
                    bigperson.pic_7037 = pic_7037;
                    bigpersonCount.pic_7037_alt = "§".repeat(pic_7037.length - 1);
                }

                let pic_7038 = person.filter(function (person) { return person.FullPath.includes("\\胸椎X光-正面\\"); });
                if (!_.isEmpty(pic_7038)) {
                    bigperson.pic_7038 = pic_7038;
                    bigpersonCount.pic_7038_alt = "§".repeat(pic_7038.length - 1);
                }

                let pic_7039 = person.filter(function (person) { return person.FullPath.includes("\\腰椎X光-正面(L-spine AP)\\"); });
                if (!_.isEmpty(pic_7039)) {
                    bigperson.pic_7039 = pic_7039;
                    bigpersonCount.pic_7039_alt = "§".repeat(pic_7039.length - 1);
                }

                let pic_7040 = person.filter(function (person) { return person.FullPath.includes("\\腰椎X光-側面(L-spine Lat)\\"); });
                if (!_.isEmpty(pic_7040)) {
                    bigperson.pic_7040 = pic_7040;
                    bigpersonCount.pic_7040_alt = "§".repeat(pic_7040.length - 1);
                }

                let pic_7061 = person.filter(function (person) { return person.FullPath.includes("\\左手X光\\"); });
                if (!_.isEmpty(pic_7061)) {
                    bigperson.pic_7061 = pic_7061;
                    bigpersonCount.pic_7061_alt = "§".repeat(pic_7061.length - 1);
                }
                let pic_7050 = person.filter(function (person) { return person.FullPath.includes("\\頭部數位斷層合成攝影\\"); });
                if (!_.isEmpty(pic_7050)) {
                    bigperson.pic_7050 = pic_7050;
                    bigpersonCount.pic_7050_alt = "§".repeat(pic_7050.length - 1);

                } let pic_7051 = person.filter(function (person) { return person.FullPath.includes("\\頸部數位斷層合成攝影\\"); });
                if (!_.isEmpty(pic_7051)) {
                    bigperson.pic_7051 = pic_7051;
                    bigpersonCount.pic_7051_alt = "§".repeat(pic_7051.length - 1);
                }

                let pic_7052 = person.filter(function (person) { return person.FullPath.includes("\\胸部數位斷層合成攝影\\"); });
                if (!_.isEmpty(pic_7052)) {
                    bigperson.pic_7052 = pic_7052;
                    bigpersonCount.pic_7052_alt = "§".repeat(pic_7052.length - 1);
                }
                let pic_7053 = person.filter(function (person) { return person.FullPath.includes("\\腹部數位斷層合成攝影\\"); });
                if (!_.isEmpty(pic_7053)) {
                    bigperson.pic_7053 = pic_7053;
                    bigpersonCount.pic_7053_alt = "§".repeat(pic_7053.length - 1);
                }

                let pic_7062 = person.filter(function (person) { return person.FullPath.includes("\\右手X光\\"); });
                if (!_.isEmpty(pic_7062)) {
                    bigperson.pic_7062 = pic_7062;
                    bigpersonCount.pic_7062_alt = "§".repeat(pic_7062.length - 1);
                }

                let pic_8009 = person.filter(function (person) { return person.FullPath.includes("\\小腿X光(正面)\\"); });
                if (!_.isEmpty(pic_8009)) {
                    bigperson.pic_8009 = pic_8009;
                    bigpersonCount.pic_8009_alt = "§".repeat(pic_8009.length - 1);
                }

                let pic_8010 = person.filter(function (person) { return person.FullPath.includes("\\小腿X光(左腳)\\"); });
                if (!_.isEmpty(pic_8010)) {
                    bigperson.pic_8010 = pic_8010;
                    bigpersonCount.pic_8010_alt = "§".repeat(pic_8010.length - 1);
                }

                let pic_8011 = person.filter(function (person) { return person.FullPath.includes("\\小腿X光(右腳)\\"); });
                if (!_.isEmpty(pic_8011)) {
                    bigperson.pic_8011 = pic_8011;
                    bigpersonCount.pic_8011_alt = "§".repeat(pic_8011.length - 1);
                }

                let pic_8012 = person.filter(function (person) { return person.FullPath.includes("\\膝蓋X光-正面\\"); });
                if (!_.isEmpty(pic_8012)) {
                    bigperson.pic_8012 = pic_8012;
                    bigpersonCount.pic_8012_alt = "§".repeat(pic_8012.length - 1);
                }

                let pic_8013 = person.filter(function (person) { return person.FullPath.includes("\\膝蓋X光-側面(左)\\"); });
                if (!_.isEmpty(pic_8013)) {
                    bigperson.pic_8013 = pic_8013;
                    bigpersonCount.pic_8013_alt = "§".repeat(pic_8013.length - 1);
                }

                let pic_8014 = person.filter(function (person) { return person.FullPath.includes("\\膝蓋X光-側面(右)\\"); });
                if (!_.isEmpty(pic_8014)) {
                    bigperson.pic_8014 = pic_8014;
                    bigpersonCount.pic_8014_alt = "§".repeat(pic_8014.length - 1);
                }

                let pic_7054 = person.filter(function (person) { return person.FullPath.includes("\\全脊椎數位X光攝影\\"); });
                if (!_.isEmpty(pic_7054)) {
                    bigperson.pic_7054 = pic_7054;
                    bigpersonCount.pic_7054_alt = "§".repeat(pic_7054.length - 1);
                }

                let pic_7055 = person.filter(function (person) { return person.FullPath.includes("\\下肢數位X光攝影\\"); });
                if (!_.isEmpty(pic_7055)) {
                    bigperson.pic_7055 = pic_7055;
                    bigpersonCount.pic_7055_alt = "§".repeat(pic_7055.length - 1);
                }

                let pic_7045 = person.filter(function (person) { return person.FullPath.includes("\\上消化道內視鏡\\"); });
                if (!_.isEmpty(pic_7045)) {
                    bigperson.pic_7045 = pic_7045;
                    bigpersonCount.pic_7045_alt = "§".repeat(pic_7045.length - 1);
                }

                let pic_7046 = person.filter(function (person) { return person.FullPath.includes("\\下消化道內視鏡\\"); });
                if (!_.isEmpty(pic_7046)) {
                    bigperson.pic_7046 = pic_7046;
                    bigpersonCount.pic_7046_alt = "§".repeat(pic_7046.length - 1);
                }

                let pic_7029 = person.filter(function (person) { return person.FullPath.includes("\\無痛大腸鏡檢查\\"); });
                if (!_.isEmpty(pic_7029)) {
                    bigperson.pic_7029 = pic_7029;
                    bigpersonCount.pic_7029_alt = "§".repeat(pic_7029.length - 1);
                }

                let pic_7030 = person.filter(function (person) { return person.FullPath.includes("\\無痛胃鏡檢查\\"); });
                if (!_.isEmpty(pic_7030)) {
                    bigperson.pic_7030 = pic_7030;
                    bigpersonCount.pic_7030_alt = "§".repeat(pic_7030.length - 1);
                }

                let pic_7031 = person.filter(function (person) { return person.FullPath.includes("\\胃鏡檢查\\"); });
                if (!_.isEmpty(pic_7031)) {
                    bigperson.pic_7031 = pic_7031;
                    bigpersonCount.pic_7031_alt = "§".repeat(pic_7031.length - 1);
                }

                let pic_7070 = person.filter(function (person) { return person.FullPath.includes("\\胃鏡病理報告\\"); });
                if (!_.isEmpty(pic_7070)) {
                    bigperson.pic_7070 = pic_7070;
                    bigpersonCount.pic_7070_alt = "§".repeat(pic_7070.length - 1);
                }

                let pic_7032 = person.filter(function (person) { return person.FullPath.includes("\\大腸鏡檢查\\"); });
                if (!_.isEmpty(pic_7032)) {
                    bigperson.pic_7032 = pic_7032;
                    bigpersonCount.pic_7032_alt = "§".repeat(pic_7032.length - 1);
                }

                let pic_7063 = person.filter(function (person) { return person.FullPath.includes("\\乙狀結腸\\"); });
                if (!_.isEmpty(pic_7063)) {
                    bigperson.pic_7063 = pic_7063;
                    bigpersonCount.pic_7063_alt = "§".repeat(pic_7063.length - 1);
                }

                // let pic_7076 = person.filter(function (person) { return person.FullPath.includes("\\雙能量X光骨質吸收儀(DXA)-髖關節\\"); });
                // if (!_.isEmpty(pic_7076)) {
                //     bigperson.pic_7076 = pic_7076;
                //     bigpersonCount.pic_7076_alt = "§".repeat(pic_7076.length - 1);
                // }

                let pic_7021 = person.filter(function (person) { return person.FullPath.includes("\\DXA 檢查\\") || person.FullPath.includes("\\雙能量X光骨質吸收儀(DXA)\\");; });
                if (!_.isEmpty(pic_7021)) {
                    bigperson.pic_7021 = pic_7021;
                    bigpersonCount.pic_7021_alt = "§".repeat(pic_7021.length - 1);
                }

                let pic_7075 = person.filter(function (person) { return person.FullPath.includes("\\DXA 左側股骨\\") || person.FullPath.includes("\\DXA DualFemur\\") || person.FullPath.includes("\\雙能量X光骨質吸收儀(DXA)-髖關節\\"); });
                if (!_.isEmpty(pic_7075)) {
                    bigperson.pic_7075 = pic_7075;
                    bigpersonCount.pic_7075_alt = "§".repeat(pic_7075.length - 1);
                }

                let pic_7091 = person.filter(function (person) { return person.FullPath.includes("\\DXA 正面脊椎\\") || person.FullPath.includes("\\雙能量X光骨質吸收儀(DXA)-腰椎\\"); });
                if (!_.isEmpty(pic_7091)) {
                    bigperson.pic_7091 = pic_7091;
                    bigpersonCount.pic_7091_alt = "§".repeat(pic_7091.length - 1);
                }
                let pic_7092 = person.filter(function (person) { return person.FullPath.includes("\\全自動乳房掃描\\") });
                if (!_.isEmpty(pic_7092)) {
                    bigperson.pic_7092 = pic_7092;
                    bigpersonCount.pic_7092_alt = "§".repeat(pic_7092.length - 1);
                }

                let pic_7020 = person.filter(function (person) { return person.FullPath.includes("\\DXA 全身\\"); });
                if (!_.isEmpty(pic_7020)) {
                    bigperson.pic_7020 = pic_7020;
                    bigpersonCount.pic_7020_alt = "§".repeat(pic_7020.length - 1);
                }
                //2023/06/12改新報的夾圖
                // let pic_7060 = person.filter(function (person) { return person.FullPath.includes(one.UserName.replaceAll("?", "") + ".jpg"); });
                // if (!_.isEmpty(pic_7060)) {
                //     bigperson.pic_7060 = pic_7060;
                //     bigpersonCount.pic_7060_alt = "§".repeat(pic_7060.length - 1);
                // }

                let pic_7060 = person.filter(function (person) { return person.FullPath.includes("\\InBody體脂肪機\\"); });
                if (!_.isEmpty(pic_7060)) {
                    bigperson.pic_7060 = pic_7060;
                    bigpersonCount.pic_7060_alt = "§".repeat(pic_7060.length - 1);
                }

                let pic_7008 = person.filter(function (person) { return person.FullPath.includes("\\靜式心電圖EKG\\"); });
                if (!_.isEmpty(pic_7008)) {
                    bigperson.pic_7008 = pic_7008;
                    bigpersonCount.pic_7008_alt = "§".repeat(pic_7008.length - 1);
                }

                let pic_7007 = person.filter(function (person) { return person.FullPath.includes("\\運動心電圖EKG\\"); });
                if (!_.isEmpty(pic_7007)) {
                    bigperson.pic_7007 = pic_7007;
                    bigpersonCount.pic_7007_alt = "§".repeat(pic_7007.length - 1);
                }

                let pic_7042 = person.filter(function (person) { return person.FullPath.includes("page-1.jpg") || person.FullPath.includes("page-2.jpg"); });
                if (!_.isEmpty(pic_7042)) {
                    bigperson.pic_7042 = pic_7042;
                    bigpersonCount.pic_7042_alt = "§".repeat(pic_7042.length - 1);
                }

                let pic_7041 = person.filter(function (person) { return person.FullPath.includes("page-3.jpg") || person.FullPath.includes("page-4.jpg"); });
                if (!_.isEmpty(pic_7041)) {
                    bigperson.pic_7041 = pic_7041;
                    bigpersonCount.pic_7041_alt = "§".repeat(pic_7041.length - 1);
                }

                let pic_7023 = person.filter(function (person) { return person.FullPath.includes("\\眼底攝影\\"); });
                if (!_.isEmpty(pic_7023)) {
                    bigperson.pic_7023 = pic_7023;
                    bigpersonCount.pic_7023_alt = "§".repeat(pic_7023.length - 1);
                }


                // bigperson.cpic = "";
                // bigpersonCount.cpic_alt = "";

                // console.log(bigperson);
                // console.log(bigpersonCount);


                //格式轉換
                Object.keys(bigperson).map(item => {
                    bigperson[item] = !_.isEmpty(bigperson[item]) ? bigperson[item].map(i => specialFormat(i.FullPath)).join(",") : null;
                })
                //變更資料源
                setRows(prevstate => (prevstate.map(item => {
                    if (item.PersonalId === personalId) {
                        return {
                            ...item,
                            pic: JSON.stringify(bigperson),
                            pic_alt: JSON.stringify(bigpersonCount)
                        }
                    } else return item
                })
                ));
                enqueueSnackbar("匹配成功", { variant: "Success", style: { whiteSpace: 'pre-line' } });
                one.pic = JSON.stringify(bigperson);
                one.pic_alt = JSON.stringify(bigpersonCount);
                // console.log(one)

                PF.instance({
                    method: "post",
                    url: PF.url + "/Match/UPDATE",
                    data: Qs.stringify({ parameter: one })
                    // headers: { token: sessionStorage.token }
                })
                    .then(function (response) {
                        // alert("完成")
                        const { TotalRecord, rows } = response.data;
                        if (TotalRecord > 0) {
                            enqueueSnackbar("圖檔更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        }
                        else {
                            enqueueSnackbar("圖檔更新失敗", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                        }
                        GetData();
                    })





            } else {
                enqueueSnackbar("匹配失敗", { variant: "warning", style: { whiteSpace: 'pre-line' } });
            }

        } else {
            alert("請輸入日期與身分ID")
        }




    }


    const handleTest2 = e => {
        e.preventDefault();
        let one;
        // const { personalId } = user;
        // const map1 = new Map(
        //     [...checkSelections]
        //         .filter(([k, v]) => v === true)
        // );
        // // let index = [...checkSelections][0][0];
        // if (!_.isEmpty(rows[[...map1.keys()][0]])) {
        //     one = rows[[...map1.keys()][0]];
        //     let personalId = one.PersonalId;


        // } else {
        //     alert("請選擇一筆")
        // }

        // console.log(checkSelections);
        // console.log(checkSelections)
        // if (!_.isEmpty(personalId)) {
        //     PF.instance({
        //         method: "post",
        //         url: PF.url + "/Match/UPDATE",
        //         data: Qs.stringify({ parameter: rows.find(item => item.PersonalId === personalId) })
        //         // headers: { token: sessionStorage.token }
        //     })
        //         .then(function (response) {
        //             // alert("完成")
        //             const { TotalRecord, rows } = response.data;
        //             if (TotalRecord > 0) {
        //                 enqueueSnackbar("圖檔更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
        //             }
        //             else {
        //                 enqueueSnackbar("圖檔更新失敗", { variant: "warning", style: { whiteSpace: 'pre-line' } });
        //             }
        //         })
        // }
    }


    const handleDateChange = (name, e, v) => {
        if (_.isNil(imageURL)) {  //已提交不得修改
            setMornJoy(prevState => ({
                ...prevState,
                [name]: {
                    ...prevState[name],
                    value: v
                }
            }));
        }
    }
    const [loading, setLoading] = React.useState(false);

    const GetData = () => {
        let date = new Date(MornJoy.CheckDate.value);
        // setLoading(true);
        PF.instance({
            method: "post",
            url: PF.url + "/Match/MatchQueryTable",
            data: Qs.stringify({ parameter: { CheckDate: MornJoy.CheckDate.value, yyyym: date.getFullYear() - 1911 + "." + moment(date).format("M"), mmdd: moment(date).format("MMDD") } }),
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                // alert("完成")
                const { TotalRecord, rows } = response.data;
                console.log(rows);
                // console.log(file);
                if (_.isEmpty(rows)) {
                    enqueueSnackbar("查無報告書資料", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                } else {
                    enqueueSnackbar("報告書資料：" + TotalRecord + "筆", { variant: "success", style: { whiteSpace: 'pre-line' } });
                }
                // setFile(file);
                setRows(prev => rows);
                setOrderRows(prev => [...PF.dataSheetGridFormat(rows, Object.keys(showColumns))])
            })

    }
    const [ItemName, setItemName] = React.useState();
    const GetItem = () => {
        // setLoading(true);
        PF.instance({
            method: "post",
            url: PF.url + "/Match/GetItem",
            data: Qs.stringify({ parameter: null }),
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                // alert("完成")
                const { TotalRecord, rows } = response.data;
                setItemName(_.chain(rows)
                    .keyBy('item_no')
                    .mapValues('title')
                    .value());
                // console.log(ItemName);

            })

    }

    const GetFile = () => {
        setLoading(true);
        let date = new Date(MornJoy.CheckDate.value);

        PF.instance({
            method: "post",
            url: PF.url + "/Match/MatchQueryFile",
            data: Qs.stringify({ parameter: { CheckDate: MornJoy.CheckDate.value, yyyym: date.getFullYear() - 1911 + "." + moment(date).format("M"), mmdd: moment(date).format("MMDD") } }),
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                // alert("完成")
                const { TotalRecord, file } = response.data;
                // console.log(rows);
                // console.log(file);

                if (_.isEmpty(file)) {
                    enqueueSnackbar("查無圖檔資料", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                } else {
                    enqueueSnackbar("圖檔資料：" + TotalRecord + "筆", { variant: "success", style: { whiteSpace: 'pre-line' } });
                }
                setLoading(false);
                setFile(file);
            })


    }

    const handleQuery = e => {
        // let date = new Date(MornJoy.CheckDate.value);

        if (!_.isEmpty(MornJoy.CheckDate.value)) {
            setLoading(true);
            GetData();
            GetFile();
            // setLoading(false);

        } else {
            alert("請輸入日期")
        }

    }
    const [MornJoy, setMornJoy] = React.useState({
        CheckDate: { name: "CheckDate", label: "健檢日期", format: "date", required: true, value: null },
        personalId: { name: "personalId", label: "身分ID", required: true },
    })
    const handleTest3 = e => {
        e.preventDefault();
        let one;
        // const { personalId } = user;
        const map1 = new Map(
            [...checkSelections]
                .filter(([k, v]) => v === true)
        );
        // let index = [...checkSelections][0][0];
        if (!_.isEmpty(rows[[...map1.keys()][0]])) {
            one = rows[[...map1.keys()][0]];
            let personalId = one.PersonalId;
            console.log(personalId)

        } else {
            alert("請選擇一筆")
        }
        GetData();

    }
    const handleCloseDialog = (value) => {
        setOpenDialog(false);
        setDialogObj(null);
        setPicObj({});
    };
    const [PicObj, setPicObj] = React.useState({})
    React.useEffect(() => {
        console.log(PicObj)
    }, [PicObj])
    const handleSaveDialog = (value) => {
        let one = {};
        one.qc_id = DialogObj?.qc_id;
        // console.log(DialogObj.qc_id)


        // bigperson.pic_7023 = pic_7023;
        // bigpersonCount.pic_7023_alt = "§".repeat(pic_7023.length - 1);
        let TempPic = {}
        Object.keys(PicObj).map(item => {
            TempPic[item] = !_.isEmpty(PicObj[item]) ? PicObj[item].join(",") : null;
        })
        one.pic = JSON.stringify(TempPic);
        // console.log(TempPic)
        let TempPicAlt = {}
        let pic_alt = {}
        Object.keys(PicObj).map(item => {

            TempPicAlt[item + "_alt"] = !_.isEmpty(PicObj[item]) ? "§".repeat(PicObj[item].length - 1) : null;

        })
        // console.log(TempPicAlt)
        one.pic_alt = JSON.stringify(TempPicAlt);
        // one.pic_alt = JSON.stringify(bigpersonCount);
        // console.log(one)

        PF.instance({
            method: "post",
            url: PF.url + "/Match/UPDATE",
            data: Qs.stringify({ parameter: one })
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                // alert("完成")
                const { TotalRecord, rows } = response.data;
                if (TotalRecord > 0) {
                    enqueueSnackbar("圖檔更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                }
                else {
                    enqueueSnackbar("圖檔更新失敗", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                }
                GetData();
                setOpenDialog(false);   //關閉彈窗
                setDialogObj(null);     //刪除Dialog
                setPicObj({});          //刪除Dialog_照片

            })

    };

    return <>
        <Paper elevation={3} style={{ margin: "10px", padding: "20px" }}>
            <DarkModeSwitch
                style={{ marginBottom: '2rem', float: "right" }}
                checked={dark}
                onChange={() => dispatch(actions.THEME_SET({ theme: !dark }))}
                onMouseDown={() => playActive()}
                size={20} />
            {/* <Typography variant="h5" gutterBottom style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline" }}>健檢報告夾帶檔案</Typography> */}

            <form ref={formRef}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    {Object.values(MornJoy).slice(0, 1).map((item, key) => {
                        if (item.format === "date") {

                            return (<KeyboardDatePicker
                                format="YYYY/MM/DD"
                                key={key}
                                views={["year", "month", "date"]}
                                // fullWidth
                                autoOk
                                autoComplete="off"
                                clearable
                                type="datetime"
                                name={item.name}
                                required={item.required}
                                error={item.error || false}
                                helperText={
                                    item.error ? (
                                        item.helperText
                                    ) : null
                                }
                                todayLabel={< TodayIcon />}
                                showTodayButton
                                minDate={item.minDate || new Date("1900-01-01")}
                                maxDate={item.maxDate || new Date("2100-01-01")}
                                clearLabel={"清除"}
                                label={item.label}
                                value={item.value}
                                inputValue={item.value}
                                onChange={(event, value) =>
                                    handleDateChange(item.name, event, value)
                                }
                            />
                            )
                        } else {
                            // return (<TextField
                            //     // variant="filled"
                            //     key={key}
                            //     helperText={item.error ? item.helperText : null}
                            //     autoComplete="off"
                            //     error={item.error || false}
                            //     required={item.required || false}
                            //     // fullWidth
                            //     name={item.name}
                            //     label={item.label}
                            //     inputProps={{ ...item }}
                            //     value={item.value}
                            //     onChange={handleTxtChange}
                            //     inputProps={{
                            //         ...item //像是minLength、pattern
                            //         // pattern: "[0-9]{4}/(0[1-9]|1[012])/(0[1-9]|1[0-9]|2[0-9]|3[01])"
                            //     }} />
                            // )

                        }

                    })}
                    <Button onClick={handleQuery} variant={"outlined"}>查找</Button>
                </MuiPickersUtilsProvider>

            </form>
            <br />
            {Object.values(MornJoy).slice(1, 2).map((item, key) => {
                if (item.format === "date") {
                    return (<KeyboardDatePicker
                        format="YYYY/MM/DD"
                        key={key}
                        views={["year", "month", "date"]}
                        // fullWidth
                        autoOk
                        autoComplete="off"
                        clearable
                        type="datetime"
                        name={item.name}
                        required={item.required}
                        error={item.error || false}
                        helperText={
                            item.error ? (
                                item.helperText
                            ) : null
                        }
                        todayLabel={< TodayIcon />}
                        showTodayButton
                        minDate={item.minDate || new Date("1900-01-01")}
                        maxDate={item.maxDate || new Date("2100-01-01")}
                        clearLabel={"清除"}
                        label={item.label}
                        value={item.value}
                        inputValue={item.value}
                        onChange={(event, value) =>
                            handleDateChange(item.name, event, value)
                        }
                    />
                    )
                } else {
                    // return (<TextField
                    //     // variant="filled"
                    //     key={key}
                    //     helperText={item.error ? item.helperText : null}
                    //     autoComplete="off"
                    //     error={item.error || false}
                    //     required={item.required || false}
                    //     // fullWidth
                    //     name={item.name}
                    //     label={item.label}
                    //     inputProps={{ ...item }}
                    //     value={user[item.name]}
                    //     onChange={handleTxtChange}
                    //     inputProps={{
                    //         ...item //像是minLength、pattern
                    //         // pattern: "[0-9]{4}/(0[1-9]|1[012])/(0[1-9]|1[0-9]|2[0-9]|3[01])"
                    //     }} />
                    // )

                }

            })}

            <Button onClick={handleTest} variant={"outlined"}>匹配更新</Button>
            {/* <Button onClick={handleTest2} variant={"outlined"}>更新</Button> */}
            {/* <Button onClick={handleTest3} variant={"outlined"}>TEST</Button> */}
            <InteriorTable
                orderRows={orderRows}                    //需轉換格式
                setRows={setRows}           //傳入方法
                rows={rows}         //原來傳入
                setOrderRows={setOrderRows}
                // columns={Object.values(showColumns)} //需轉換格式
                showColumns={showColumns}
                setColumns={setColumns}     //傳入方法
                columns={columns}   //原來傳入
                enableCheck={enableCheck}   //不允許更改
                multiChk={multiChk} //允許多選checkBOx
                checkSelections={checkSelections}       //checkBox
                setCheckSelections={setCheckSelections} //checkBox方法
                listRef={listRef}   //用來scroll to an item
                pageCount={pageCount}
                pageNo={pageNo}
                setPageNo={setPageNo}
                handleDoubleClick={handleDoubleClick}
                selected={selected}
                setSelected={setSelected}
                defaultFrozen={1}
                defaultWidth={700}
            />
            <Dialog onClose={handleCloseDialog} open={openDialog} fullWidth={true} maxWidth={"xl"}>
                <DialogTitle style={{ background: indigo[300] }}>
                    <Grid container alignItems="center" style={{ textAlign: "center", alignItems: "center" }}>
                        <Typography className={classes.chip}>姓名：</Typography>
                        <Typography variant="h4" className={classes.chip}>{DialogObj?.UserName || "王小明"}</Typography>
                        <Divider orientation="vertical" flexItem />
                        <Typography className={classes.chip}>身分證：</Typography>
                        <Typography variant="h4" className={classes.chip}>{DialogObj?.PersonalId || "A123456789"}</Typography>
                        <Divider orientation="vertical" flexItem />
                        <Typography className={classes.chip}>條碼號：</Typography>
                        <Typography variant="h4" className={classes.chip}>{DialogObj?.barcode || "20210101000"}</Typography>
                        <IconButton className={classes.closeButton} onClick={handleCloseDialog} >
                            <CloseIcon color="primary" />
                        </IconButton>
                    </Grid>
                </DialogTitle>
                <DialogContent dividers>
                    {Object.keys(GaugeItem).map(CheckCategory => {
                        return (
                            <>
                                <Typography variant="h4" >{CheckCategory}</Typography>
                                {GaugeItem[CheckCategory].map(itemNo => {
                                    return (
                                        <>
                                            <div key="Subheader" style={{ paddingTop: "30px", display: "block" }}>

                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                    startIcon={<AssignmentTurnedInIcon />}
                                                >
                                                    <Typography variant="h6" >{itemNo.ItemName}</Typography>
                                                </Button>
                                                <Typography >{itemNo.Value}</Typography>
                                            </div>
                                            <ImgList DataSource={PicObj || {}} setPicObj={setPicObj} ItemName={ItemName} ItemNo={itemNo.ItemNo} />

                                        </>
                                    )
                                }

                                )}

                            </>
                        )
                    }

                    )}
                    {/* <ImgList DataSource={PicObj || {}} setPicObj={setPicObj} ItemName={ItemName} ItemNo={"7033"} /> */}


                </DialogContent>
                <DialogActions style={{ background: indigo[300] }}>
                    <Button onClick={handleSaveDialog} color="primary" variant='contained'>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            {/* <Example /> */}
        </Paper>
        <Backdrop className={classes.backdrop} open={loading} >
            <CircularProgress color="inherit" />
        </Backdrop>
    </>
}


export default Match


